import * as React from "react";
// import { Admin } from 'react-admin';
import { Admin, Resource, ListGuesser, fetchUtils, EditGuesser, CustomRoutes, Title } from 'react-admin';
// import jsonServerProvider from 'ra-data-json-server';
import treeqlProvider from 'ra-data-treeql';
import authProvider from './AuthProvider';
import { Master_kabList, Master_kabEdit, Master_kabCreate } from './pages/master_kab';
import { MitraList, MitraEdit, MitraCreate } from './pages/mitra';
import customProvider from './constant/CustomProvider'
import { httpClient, url_api } from "./constant/constant";
import Dashboard from "./pages/dashboard";
import presensi_ppid from "./pages/dashboard";
import Faq from "./pages/faq";
import { Route } from 'react-router-dom';
import MitraImport from "./pages/mitra_import";
import { SbmlCreate, SbmlEdit, SbmlList } from "./pages/sbml";
import SbmlImport from "./pages/sbml_import";
import { AlokasiCreate, AlokasiEdit, AlokasiList } from "./pages/alokasi";
import { Report_sumList } from "./pages/report_sum";

import UserIcon from '@mui/icons-material/Group';
import KeyIcon from '@mui/icons-material/Key';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AddTaskIcon from '@mui/icons-material/AddTask';
import TaskIcon from '@mui/icons-material/Task';
import { MyLayout } from "./constant/MyLayout";
import { AutentifikasiCreate, AutentifikasiEdit, AutentifikasiList } from "./pages/autentifikasi";
import { PersetujuanCreate, PersetujuanEdit, PersetujuanList } from "./pages/persetujuan";
import { Report_targetList } from "./pages/report_target";
import { QueueEdit, QueueList } from "./pages/queue";
import { Petugas_pstCreate, Petugas_pstEdit, Petugas_pstList } from "./pages/petugas";
import { PenilaianList } from "./pages/penilaian";
import { SurveyEdit, SurveyList } from "./pages/survey";
import { Jadwal_piketCreate, Jadwal_piketEdit, Jadwal_piketList } from "./pages/jadwal_piket";
import { Jadwal_ppid_piketCreate, Jadwal_ppid_piketEdit, Jadwal_ppid_piketList } from "./pages/jadwal_piket_ppid";
import PiketImport from "./pages/piket_import";
import PiketPPIDImport from "./pages/piket_ppid_import";
import { Survey_onlineList } from "./pages/survey_online";
import { PresensiPpidList } from "./pages/presensi_ppid";
import BestEmployee from "./pages/best_employee";
import { ReportQueueList } from "./pages/report_queue";
import { Penilaian_siseraList } from "./pages/sisera";
import { View_rekap_jadwalList } from "./pages/rekap_jadwal_piket";
import { Penilaian_piketEdit, Penilaian_piketList } from "./pages/penilaian_piket";
import { Penilaian_piketEdit_ppid, Penilaian_piketList_ppid } from "./pages/penilaian_piket_ppid";

import ScanQR from "./pages/ScanQR";
import PresenceCreate from "./pages/PresenceCreate";
import PresenceCreatePPID from "./pages/PresenceCreatePPID";

import { Presensi_Edit } from "./pages/PresenceCreate";

const dataProvider = customProvider(url_api, httpClient);


// const App = () => <Admin dataProvider={dataProvider} />;
const App = () => (
      <Admin layout={MyLayout} dashboard={Dashboard} dataProvider={dataProvider} authProvider={authProvider} requireAuth={true}>
          <Title>Dashboard Antrian</Title>
          <Resource name="autentifikasi" list={AutentifikasiList} edit={AutentifikasiEdit} create={AutentifikasiCreate} icon={KeyIcon} />
          {/* <Resource name="queue" list={AutentifikasiList} edit={AutentifikasiEdit} create={AutentifikasiCreate} icon={KeyIcon} /> */}
          <Resource name="queue" list={QueueList} edit={QueueEdit} icon={KeyIcon} />
          <Resource name="report_queue" list={ReportQueueList} icon={KeyIcon} />
          <Resource name="petugas_pst" list={Petugas_pstList} edit={Petugas_pstEdit} create={Petugas_pstCreate} icon={KeyIcon} />
          <Resource name="penilaian" list={PenilaianList} icon={KeyIcon} />
          <Resource name="penilaian_sisera" list={Penilaian_siseraList} icon={KeyIcon} />
          <Resource name="survey_online" list={Survey_onlineList} icon={KeyIcon} />
          <Resource name="survey" list={SurveyList} edit={SurveyEdit} icon={KeyIcon} />
          <Resource name="jadwal_piket" list={Jadwal_piketList} edit={Jadwal_piketEdit} create={Jadwal_piketCreate} icon={KeyIcon} />
          <Resource name="jadwal_piket_ppid" list={Jadwal_ppid_piketList} edit={Jadwal_ppid_piketEdit} create={Jadwal_ppid_piketCreate} icon={KeyIcon} />
          <Resource name="view_rekap_jadwal_final" list={View_rekap_jadwalList} icon={KeyIcon} />
          <Resource name="penilaian_piket" list={Penilaian_piketList} edit={Penilaian_piketEdit} icon={KeyIcon} />
          <Resource name="presensi_pojok" create={PresenceCreate}/>
          
          <Resource name="presensi_ppid" list={PresensiPpidList} create={PresenceCreatePPID}/>
          <Resource name="penilaian_piket_ppid" list={Penilaian_piketList_ppid} edit={Penilaian_piketEdit_ppid} icon={KeyIcon} />
          {/* <Resource name="master_kab" list={Master_kabList} edit={Master_kabEdit} />
          <Resource name="mitra" list={MitraList} edit={MitraEdit} create={MitraCreate} icon={UserIcon} />
          <Resource name="sbml" list={SbmlList} edit={SbmlEdit} create={SbmlCreate} />
          <Resource name="alokasi" list={AlokasiList} edit={AlokasiEdit} create={AlokasiCreate} icon={AddTaskIcon} />
          <Resource name="persetujuan" list={PersetujuanList} edit={PersetujuanEdit} bulkActionButtons={false} icon={TaskIcon} />
          <Resource name="report_target" list={Report_targetList} bulkActionButtons={false} icon={AssessmentIcon} />
          <Resource name="report_sum" list={Report_sumList} bulkActionButtons={false} icon={AssessmentIcon} /> */}
          <CustomRoutes>
            <Route exact path="/scanqr" element={<ScanQR />} />
            <Route exact path="/faq" element={<Faq />} />
            <Route exact path="/best_employee" element={<BestEmployee />} />
            <Route exact path="/mitra/import" element={<MitraImport />} />
            <Route exact path="/sbml/import" element={<SbmlImport />} />
            <Route exact path="/jadwal_piket/import" element={<PiketImport />} />
            <Route exact path="/jadwal_piket_ppid/import" element={<PiketPPIDImport />} />
          </CustomRoutes>
      </Admin>
);

export default App;